/* eslint-disable max-len */
import moment from 'moment';
import Misc from '../misc';
import {AVAILABLE_LANGUAGES} from "../constants/dashboard";

const appRootPath = Misc.scriptPath('../');

const AmazonS3RootPath = 'https://s3.amazonaws.com';
const FiltersImagesBucket = 'filter-images';
const FeaturesThumbnails = 'features-thumbnails';

export function getMasterFabricatorId(masterFabricatorIds, tool) {
  console.log(13, tool, masterFabricatorIds, masterFabricatorIds[tool]);
  if (!masterFabricatorIds[tool]) {
    if (tool === "laundryroom") {
      return masterFabricatorIds["laundryRoom"]
    }
    return masterFabricatorIds.bathroom || masterFabricatorIds.kitchen;
  }
  else
    return masterFabricatorIds[tool];
}

export function getCurrentFabricatorId(state) {
  const {auth, asCustomer} = state;
  return asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
}

export function getCurrentFabricatorName(state) {
  const {auth, asCustomer} = state;
  return asCustomer.activeEntity && asCustomer.activeEntity.companyName
    ? asCustomer.activeEntity.companyName
    : auth.customerName
}

export function imagesPath(path) {
  return `${appRootPath}${path}`;
}

export function getCurrencySymbol(currencyText) {
  var symbol = "$";
  if(currencyText && typeof currencyText == 'string') {
    switch(currencyText.toLowerCase()) {
      case "eur":
        symbol = "€";
        break;
      case "gbp":
        symbol = "£";
        break;
    }
  }
  return symbol;
}

export function getPricingAlgorithmIcons() {
  const gpai = getPricingAlgorithmIcon;
  return [
    gpai("Discount"),
    gpai("Exotic"),
    gpai("Granite"),
    gpai("Jumbo"),
    gpai("Laminate"),
    gpai("Marble"),
    gpai("Minimum"),
    gpai("Quartz"),
    gpai("Slab"),
    gpai("Special"),
    gpai("SquareFeet", "Square Feet")
  ]
}

function getPricingAlgorithmIcon(icon, name) {
  name = name || icon;
  const iconPath = imagesPath('images/pricing-algorithm-icons/');
  return {
    fileName: iconPath + icon + '.svg',
    activeFileName: iconPath + 'active/' + icon + '.svg',
    name: name
  };
}

export const getFilterImage = (name, randomSeed = false) => AmazonS3RootPath + '/' + FiltersImagesBucket + '/' + name
  + (randomSeed ? '?' + (new Date()).getTime() : '');

export const getFeatureImage = (feature) => `${AmazonS3RootPath}/${FeaturesThumbnails}/feature-${feature.imageKey}.png`;

export const bkgImage = name => `url('${name}')`;

export const isImageFile = name => /\.(jpe?g|png|gif)$/i.test(name);

/**
 * Returns a hardcoded feature description, this will be removed later
 * @param featureGroupName {string}
 */
export function getFeatureGroupDescription(featureGroupName) {
  switch ((featureGroupName || '').toLowerCase()) {
    case 'material':
      return 'How many square feet of material do you need for your project? If you need help calculating, press the square foot calculator button.';
    case 'room':
      return 'Please select the room in which you would like new countertops.';
    case 'edge profile':
      return 'The edge profile of the countertop is a small detail among many in the kitchen. The shape of your countertop\'s edge can have a huge effect on function, impacting everything from cleaning to safety.';
    case 'cutouts':
      return 'Select the Cutouts you will need for your new countertops.';
    case 'faucets':
    case 'faucet':
      return 'Do you need a faucet for your countertop project? If so, select the faucet that you would like to use for your countertops.';
    case 'sinks':
    case 'sink':
      return 'Do you need a sink for your countertop project? If so, select the sink that you would like to use for your countertops.';
    case 'counter top removal':
    case 'countertop removal':
      return 'Professional removal and disposal of your existing countertop material.';
    case 'radius':
      return 'Radius corners refer to the degree of “roundness” the countertop corners will have “Soft” corners are the corners that are exposed to traffic areas or where people walk.';
    case 'plumbing':
      return 'If you would like the plumbing work done by our team please select an option.';
    case 'backsplash':
      return 'Select a Backsplash option for your job.';
    case 'sealer':
      return 'Natural Stone requires some special considerations, but simple care and maintenance will keep your Natural Stone Countertops looking beautiful.';
    case 'hourly labor':
      return 'Hourly labor may be charged for work that needs to be done that may not be part of a standard installation or fabrication job.';
    case 'trip charge':
      return 'For service outside of our normal service range we may charge a trip charge to compensate for time and fuel.';
    case 'milling down':
      return 'Does your job require milling down of materials?  If so please enter the square footage below.';
    case 'template':
      return 'Please choose a template option below.';
    default:
      return `${featureGroupName} - N/A`;
  }
}

const featureGroupNameToIcon = {
  '10 year sealer': 'sealer.svg',
  'cabinet': 'cabinets.svg',
  'top mount sink cutout': 'topmount-sink-cutout.svg',
  'under mount sink cutout': 'undermount-sink-cutout.svg',
  'counter top removal': 'countertop-removal.svg',
  'cooktop cutout': 'range-top-cutout.svg',
  'cutout': 'cutouts.svg',
  'faucet': 'faucets.svg',
  'floor': 'flooring.svg',
  'range-hood-x': 'range-hood.svg',
  'range-hood-z': 'range-hood.svg',
  'refridgerator': 'refrigerator.svg',
  'removal': 'countertop-removal.svg',
  'room(s) installed': 'room.svg'
};

function normalizeIconFileName(featureGroupName) {
  return ((featureGroupName || '')).toLowerCase().replace(/\s/g, '-').replace(".svg", "") + '.svg';
}

export function getFeatureGroupIconURL(featureGroupName, enabled) {
  if (typeof enabled === 'undefined') enabled = true;
  const name = ((featureGroupName || '')).toLowerCase();
  const container = (enabled ? 'enabled' : 'disabled');
  if (name in featureGroupNameToIcon) {
    return imagesPath(`images/icons/pj-scope-icons/${container}/${featureGroupNameToIcon[name]}`);
  }

  const fileName = normalizeIconFileName(name);
  //console.warn(`No image available for ${featureGroupName}`);
  return imagesPath(`images/icons/pj-scope-icons/${container}/${fileName}`);
}

export const UNIT_MEASUREMENTS = ['Each', 'Linear Feet', 'Linear Inches', 'Square Feet', 'Square Inches', 'Flat Rate',
  'No Quantity', 'SQFT', 'LNFT', 'SF', 'LF'];

export const SHIPPING_TIMES = ["Overnight", "1 day", "1-2 days", "1-3 day", "2-3 days", "3-5 days", "5-7 days",
  "1-2 weeks", "2-3 weeks", "2-4 weeks", "3-5 weeks", "4-6 weeks", "5-7 weeks", "6-8 weeks", "8-12 weeks"];

export function createCalendarMonthDays(visibleDate, selectedDate) {
  let cnt = 0;
  const mom = moment(visibleDate);
  let res = [];
  mom.date(1);
  const dayOfWeek = mom.day();
  for (let i = 0; i < dayOfWeek; i++) {
    res.push({text: '', isSelectionVisible: false, key: ('prefix' + i)});
    cnt++;
  }

  const daysInMonth = mom.daysInMonth();
  for (let i = 0; i < daysInMonth; i++) {
    const isSelectionVisible = (visibleDate.month() === selectedDate.month() &&
      selectedDate.date() === (i + 1) &&
      selectedDate.year() === visibleDate.year());
    res.push({text: i + 1, isSelectionVisible: isSelectionVisible, key: ('day' + i)});
    cnt++;
  }

  const moreCnt = 7 - (cnt % 7);
  for (let i = 0; moreCnt !== 7 && i < moreCnt; i++) {
    res.push({text: '', isSelectionVisible: false, key: ('postfix' + i)});
  }

  return res;
}

/**
 * Get's the date part only from a moment datetime instance.
 * @param datetime {Object.<moment>}
 * @returns {string}  Date in format MM/dd/yyyy
 */
export function getDatePart(datetime) {
  // return moment.utc(datetime).format('L')
  return datetime.format('L');
}

/**
 * Creates a plain array for an hierarchical one
 * @param items - array of items where a property contains sub-items
 * @param subItemsGetter - a getter that returns the property with sub-items
 */
export function unwindHierarchy(items, subItemsGetter) {
  let result = (items && items.length) ? [].concat(items) : [];

  items && items.forEach(item => result = result.concat(unwindHierarchy(subItemsGetter(item), subItemsGetter)));

  return result;
}

const sufixes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

export function formatFileSize(fileSize) {
  const i = Math.floor(Math.log(fileSize) / Math.log(1024));
  return !fileSize && '0 Bytes' || (fileSize / Math.pow(1024, i)).toFixed(2) + " " + sufixes[i];
}

/**
 * Validate a file extension against given extensions
 * @param fileName {string}
 * @param validExtensions {Array<string>}
 */
export function validateFileExtension(fileName, validExtensions) {
  const ext = (fileName || "").split('.').pop().toLowerCase();
  return validExtensions.indexOf('.' + ext) !== -1;
}

/**
 * Validates where a given hour:minute is in range of needed hour and minute
 * @param hour {int}
 * @param minute {int}
 * @param hourStart {int}
 * @param minuteStart {int}
 * @param hourEnd {int}
 * @param minuteEnd {int}
 * @returns {boolean}
 */
export function inRange(hour, minute, hourStart, minuteStart, hourEnd, minuteEnd) {
  return ((hour >= hourStart && hour <= hourEnd)
    && (minute >= minuteStart && minute <= minuteEnd));
}

export function invertSortOrder(sortOrder) {
  return sortOrder === 'asc' ? 'desc' : 'asc';
}

export function getSizedThumbnailUrl(url, size, useUnderScore = false) {
  if(url.substring(0, 4) !== 'http')
    return url;
  return useUnderScore
    ? `${url.substring(0, url.lastIndexOf('.'))}_${size}x${size}${url.substring(url.lastIndexOf('.'))}`
    : `${url.substring(0, url.lastIndexOf('.'))}(${size}x${size})${url.substring(url.lastIndexOf('.'))}`;
}

export function cutText(text, maxLength = 15) {
  if (!text || text.length <= maxLength)
    return text;
  return text.substr(0, maxLength) + '...';
}

const arrayMoveMutate = (array, from, to) => {
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
};

export const arrayMove = (array, from, to) => {
  array = array.slice();
  arrayMoveMutate(array, from, to);
  return array;
};

const groupableSuffixes = [' s', ' d', ' D', ' S'];

export function replaceSuffix(str, suffix) {
  const idx = str.indexOf(suffix, str.length - suffix.length);
  if (idx !== -1) {
    return [str.slice(0, -suffix.length), true];
  }
  return [str, false];
}

export const getGroupAbleName = name => {
  for (const suffix of groupableSuffixes) {
    const [newStr, replaced] = replaceSuffix(name, suffix);
    if (replaced)
      return newStr;
  }
  return name;
};

export const sortByOrder = (array) => {
  return array.sort((a, b) => a.order !== b.order ? a.order < b.order ? -1 : 1 : 0); // sort by order property
};

export const toFixedPrice = (price) => {
  if (Math.round(price) !== price) {
    price = price.toFixed(2);
  }
  return price
};

export const getUrlParam = (queryParam) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(queryParam);
}

export const getMultiNamesObject = (defaultValue = "") => {
  let names = {};
  AVAILABLE_LANGUAGES.forEach(locale => names[locale] = defaultValue || "");
  return names
}

export const needToSync = (groupName) =>{
  switch ((groupName || '').toUpperCase()) {
    case "BACKSPLASH":
    case "COUNTERTOP":
    case "CENTER ISLAND COUNTERTOP":
      return true;
    default:
      return false;
  }
}

/**
 * Returns next max integer current from array of objects, for example
 * [] => 1
 * [{id: 1, someProp: ""}, {id: 3, someProp: ""}, {id: 6, someProp: ""}] => 7
 * @param array {array}
 * @param property {string}
 * @param startingFrom {number}
 * @returns {number}
 */
export const getNextMaxNumberFromList = (array, property, startingFrom = 1) => {
  return array.length ? Math.max(...array.map(arrayItem => +arrayItem[property])) + 1 : startingFrom;
}

/**
 * Returns base 64 image on input type file change
 * @param event {event}
 * @param onload {function}
 * @param errorBox_Show {function}
 * @param intl {object}
 */
export const getBase64ImgOnInputChange = (event, onload = () => {}, errorBox_Show = () => {}, intl) => {

  const files = (event.dataTransfer) ? event.dataTransfer.files : (event.target) ? event.target.files : null;
  if (!files || !files.length) {
    console.log("No Files selected");
    return;
  }
  const file = files[0];
  if (file.size > 12 * 1024 * 1024) {
    errorBox_Show({
      title: intl.formatMessage({id: "messageBox.errorTitle"}),
      text: intl.formatMessage({id: "account.logo.popupErrorSize"}),
      rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
      isRightButtonVisible: true
    });
    return;
  }
  if (!isImageFile(file.name)) {
    errorBox_Show({
      title: intl.formatMessage({id: "messageBox.errorTitle"}),
      text: intl.formatMessage({id: "account.logo.popupErrorImage"}),
      rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
      isRightButtonVisible: true
    });
    return;
  }
  const reader = new FileReader();
  reader.onload = onload;
  reader.readAsDataURL(file);
}
